import React from 'react';

const LegalPage = () => {
  return (
    <div className="min-h-screen pt-20 bg-[#FAFAFA]" data-testid="legal-page">
      <div className="bg-[#0A0A0A] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-['Playfair_Display'] mb-4">Mentions légales</h1>
        </div>
      </div>
      <div className="container-custom py-12 max-w-3xl">
        <div className="bg-white border border-[#E5E5E5] p-8 md:p-12 space-y-8 font-['Outfit']">
          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">Éditeur du site</h2>
            <p className="text-[#666666]">
              Domaine du Normont<br />
              45 minutes de Paris<br />
              Email : contact@domainedunormont.fr
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">Hébergement</h2>
            <p className="text-[#666666]">
              Le site est hébergé par Emergent<br />
              Site web : emergent.sh
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">Propriété intellectuelle</h2>
            <p className="text-[#666666]">
              L'ensemble du contenu de ce site (textes, images, vidéos) est protégé par le droit d'auteur. 
              Toute reproduction, même partielle, est interdite sans autorisation préalable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">Protection des données</h2>
            <p className="text-[#666666]">
              Conformément au RGPD, vous disposez d'un droit d'accès, de modification et de suppression 
              de vos données personnelles. Pour exercer ce droit, contactez-nous à contact@domainedunormont.fr.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">Cookies</h2>
            <p className="text-[#666666]">
              Ce site utilise des cookies essentiels au fonctionnement du service. 
              En naviguant sur ce site, vous acceptez l'utilisation de ces cookies.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
